import { OtpLogin } from '@/components/otp-login';
import { fetch_draft } from '@/features/onboarding/api';

/**
 * Vendor login (route `/login`). A vendor who has already submitted their
 * onboarding application skips the flow and lands on their dashboard; everyone
 * else continues (or starts) onboarding.
 */
export function LoginPage() {
  async function resolve_destination(): Promise<string> {
    const draft = await fetch_draft();
    return draft?.submitted_at ? '/vendor/app' : '/onboarding';
  }

  return (
    <OtpLogin
      role="vendor"
      title="Vendor Console"
      subtitle="Pet Marketplace · Onboarding sandbox"
      success_path="/onboarding"
      resolve_success_path={resolve_destination}
    />
  );
}
